import { lazy, Suspense } from 'react';
import LoadingCom from '../../components/LoadingCom';
import PageErrorBoundary from '../../components/PageErrorBoundary';

const Company = lazy(() => import(/* webpackPrefetch: true */ './Index'));

export default function SuspendedCompanySettingsPage(props: any) {
  return (
    <PageErrorBoundary>
      <Suspense fallback={<LoadingCom />}>
        <Company {...props} />
      </Suspense>
    </PageErrorBoundary>
  );
}
